// This file is used to extend the default routes
import DefaultTemplate from './default-template';
import LiveTemplate from './live-template';

import { getRoutesList } from '@om-fe/core/core/routing/default-routes';
import { DefaultRoutesProps, RouteModel } from '@om-fe/core/core/routing/utils';

export function getRoutes({ lang }: DefaultRoutesProps): Array<Partial<RouteModel>> {
    const newRoute = getRoutesList({
        lang,
        templates: {
            defaultTemplate: DefaultTemplate,
            liveTemplate: LiveTemplate,
        }
    });

    return newRoute;
}
